import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import { I18nProvider } from "@/lib/i18n";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { Chatbot } from "@/components/Chatbot";
import { ScrollProgress } from "@/components/ScrollProgress";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";

import HomePage from "@/pages/Home";
import ServicesPage from "@/pages/Services";
import ServicePage from "@/pages/ServicePage";
import AboutPage from "@/pages/About";
import PortfolioPage from "@/pages/Portfolio";
import ProjectDetailPage from "@/pages/ProjectDetail";
import ContactPage from "@/pages/Contact";
import LegalPage from "@/pages/Legal";
import BookPage from "@/pages/Book";
import BlogPage from "@/pages/Blog";
import BlogCategoryPage from "@/pages/BlogCategory";
import BlogArticlePage from "@/pages/BlogArticle";
import LoginPage from "@/pages/Login";
import AccountPage from "@/pages/Account";
import AdminDashboardPage from "@/pages/AdminDashboard";
import { AuthProvider } from "@/lib/AuthContext";
import { AuthCallback } from "@/components/auth/AuthCallback";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const AppRoutes = () => {
  const location = useLocation(); // read hash from here, not window.location.hash (not reactive)
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/services/:slug" element={<ServicePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/portfolio" element={<PortfolioPage />} />
      <Route path="/projects/:slug" element={<ProjectDetailPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:category" element={<BlogCategoryPage />} />
      <Route path="/blog/:category/:slug" element={<BlogArticlePage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/book" element={<BookPage />} />
      <Route path="/legal/:slug" element={<LegalPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboardPage /></ProtectedRoute>} />
      <Route path="*" element={<HomePage />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App dark">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <ScrollProgress />
            <Header />
            <AppRoutes />
            <Footer />
            <Chatbot />
            <FloatingWhatsApp />
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
